import { ListView } from '@progress/kendo-react-listview';
import { useState } from 'react';
import { Pager } from '@progress/kendo-react-data-tools';
import MonitorUserStatInfo from './monitorUserStatInfo';

// 리스트 뷰 컴포넌트
const MonitorUserStatList = ({dataSource }) => {
  return(
    <>
    <div className = "scroolY userInfoList">
    {  dataSource.length !== 0 ? (
      <ListView data={dataSource} item={MonitorUserStatInfo} />
      ): <span className = "none-data">데이터가 존재하지 않습니다.</span>
    }
    </div>
    </>
  )
}

export default MonitorUserStatList;